<span class="portal-status-pill" [ngClass]="toneClass">
  <span class="portal-status-pill__dot" *ngIf="showDot"></span>
  {{ displayLabel }}
</span>
